import {
  createContext,
  useContext,
  useState,
  Dispatch,
  SetStateAction,
  ReactNode,
} from "react";

// Context type definition remains the same
interface SidebarCollapseContextType {
  isCollapsed: boolean;
  openStatus: "open" | "closed" | "hover";
  setIsCollapsed: Dispatch<SetStateAction<boolean>>;
  setOpenStatus: Dispatch<SetStateAction<"open" | "closed" | "hover">>;
}

// Context creation remains the same
const SidebarCollapseContext = createContext<SidebarCollapseContextType | null>(
  null
);

// Custom hook remains the same
export const useSidebarCollapse = () => {
  const context = useContext(SidebarCollapseContext);
  if (!context) {
    throw new Error(
      "useSidebarCollapse must be used within a SidebarCollapseProvider"
    );
  }
  return context;
};

interface SidebarCollapseProviderProps {
  children: ReactNode;
}

export const SidebarCollapseProvider = ({
  children,
}: SidebarCollapseProviderProps) => {
  const [isCollapsed, setIsCollapsed] = useState(false); // Default state
  const [openStatus, setOpenStatus] = useState<"open" | "closed" | "hover">(
    "open"
  );

  const value = {
    isCollapsed,
    openStatus,
    setIsCollapsed,
    setOpenStatus,
  };

  return (
    <SidebarCollapseContext.Provider value={value}>
      {children}
    </SidebarCollapseContext.Provider>
  );
};
